import { configureDevStore } from './configureDevStore';
import { configureProdStore } from './configureProdStore';

export const configureStore = process.env.NODE_ENV === 'production' ? configureProdStore : configureDevStore;
